<template>
  <div class="radio-button-container">
    <VButton :on-click="() => onChange(option)"
             class="radio-button" :type="selectedId===option.id ? 'primary' : 'secondary'"
             v-for="(option) of options" :key="option.id"
    >
      {{ option.label }}
    </VButton>
  </div>
</template>

<script>
import VButton from './VButton'

export default {
  name: 'RadioButtons',
  components: { VButton },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: String,
      default: ''
    },
    onChange: {
      type: Function,
      default: () => {
      }
    }
  }
}
</script>

<style scoped lang="scss">

.radio-button-container {

  .radio-button + .radio-button {
    border-left: 0;
  }

  .radio-button:not(:first-child):not(:last-child) {
    border-radius: 0;
  }

  .radio-button:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .radio-button:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

</style>
